// Package Imports
import { queryOptions, useMutation } from '@tanstack/react-query'

// Core Imports
import type { TResponseError } from '@/core/types/axios'
import type { TMutation } from '@/core/types/react-query'
import type { TAdminListParams } from '@/core/lib/table-query'

// Module Imports
import {
  createTeamLogo,
  deleteTeamLogo,
  getTeamLogoList,
  replaceTeamLogo,
  setTeamLogoActive,
} from '@/modules/team-logo/team-logo.service'
import type {
  TCreateTeamLogoRequest,
  TReplaceTeamLogoRequest,
  TSetTeamLogoActiveRequest,
} from '@/modules/team-logo/team-logo.types'

export const teamLogoListQueryOptions = (params: TAdminListParams) =>
  queryOptions({
    queryKey: ['teamLogoList', params],
    queryFn: () => getTeamLogoList(params),
  })

export function useCreateTeamLogo({
  onSuccess,
  onError,
}: TMutation<void, TResponseError, TCreateTeamLogoRequest>) {
  return useMutation<void, TResponseError, TCreateTeamLogoRequest>({
    mutationFn: createTeamLogo,
    onSuccess,
    onError,
  })
}

export function useReplaceTeamLogo({
  onSuccess,
  onError,
}: TMutation<void, TResponseError, TReplaceTeamLogoRequest>) {
  return useMutation<void, TResponseError, TReplaceTeamLogoRequest>({
    mutationFn: replaceTeamLogo,
    onSuccess,
    onError,
  })
}

export function useSetTeamLogoActive({
  onSuccess,
  onError,
}: TMutation<void, TResponseError, TSetTeamLogoActiveRequest>) {
  return useMutation<void, TResponseError, TSetTeamLogoActiveRequest>({
    mutationFn: setTeamLogoActive,
    onSuccess,
    onError,
  })
}

export function useDeleteTeamLogo({
  onSuccess,
  onError,
}: TMutation<void, TResponseError, string>) {
  return useMutation<void, TResponseError, string>({
    mutationFn: deleteTeamLogo,
    onSuccess,
    onError,
  })
}
